import React from 'react';
import './Sitemap.css';
import { motion } from 'framer-motion';
import { FaTerminal, FaMapSigns, FaLayerGroup, FaShieldVirus, FaArrowRight } from 'react-icons/fa';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Sitemap = () => {
    return (
        <div className="sitemap-container">
            <Navbar />

            <div className="line-background">
                {[...Array(6)].map((_, i) => (
                    <div key={i} className="bg-line" style={{ left: `${(i + 1) * 16.66}%` }}></div>
                ))}
            </div>

            <section className="sitemap-hero">
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1 }}
                    className="hero-orb"
                ></motion.div>
                <div className="container">
                    <motion.h1
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                    >
                        Site Index<span>.</span>
                    </motion.h1>
                    <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.4 }}
                    >
                        Mapping the architectural landscape of Nimai Solutions.
                    </motion.p>
                </div>
            </section>

            <div className="modern-sitemap-wrapper">
                <div className="sitemap-node-system">
                    {/* Node 1: CORE */}
                    <motion.div
                        className="sitemap-node"
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                    >
                        <div className="node-sidebar">
                            <div className="node-number">01</div>
                            <div className="node-icon"><FaMapSigns /></div>
                        </div>
                        <div className="node-content">
                            <h3>Core Navigation</h3>
                            <div className="node-links">
                                <a href="/">Entrance <FaArrowRight /></a>
                                <a href="/about">Intelligence <FaArrowRight /></a>
                                <a href="/contact">Direct Link <FaArrowRight /></a>
                            </div>
                        </div>
                    </motion.div>

                    {/* Node 2: TECH */}
                    <motion.div
                        className="sitemap-node"
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                    >
                        <div className="node-sidebar">
                            <div className="node-number">02</div>
                            <div className="node-icon"><FaTerminal /></div>
                        </div>
                        <div className="node-content">
                            <h3>Tech Stack</h3>
                            <div className="node-links">
                                <a href="/#services">Cloud Core <FaArrowRight /></a>
                                <a href="/#services">Web Systems <FaArrowRight /></a>
                                <a href="/#services">Mobile Matrix <FaArrowRight /></a>
                                <a href="/#services">Design Logic <FaArrowRight /></a>
                            </div>
                        </div>
                    </motion.div>

                    {/* Node 3: ECOSYSTEM */}
                    <motion.div
                        className="sitemap-node"
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                    >
                        <div className="node-sidebar">
                            <div className="node-number">03</div>
                            <div className="node-icon"><FaLayerGroup /></div>
                        </div>
                        <div className="node-content">
                            <h3>Ecosystem</h3>
                            <div className="node-links">
                                <a href="/portfolio">Archive <FaArrowRight /></a>
                                <a href="/process">Methodology <FaArrowRight /></a>
                                <a href="/blog">Blog &amp; Insights <FaArrowRight /></a>
                                <a href="/#careers">Opportunities <FaArrowRight /></a>
                            </div>
                        </div>
                    </motion.div>

                    {/* Node 4: PROTOCOLS */}
                    <motion.div
                        className="sitemap-node"
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                    >
                        <div className="node-sidebar">
                            <div className="node-number">04</div>
                            <div className="node-icon"><FaShieldVirus /></div>
                        </div>
                        <div className="node-content">
                            <h3>Protocols</h3>
                            <div className="node-links">
                                <a href="/privacy-policy">Privacy <FaArrowRight /></a>
                                <a href="/terms-conditions">Usage <FaArrowRight /></a>
                                <a href="/cookie-policy">Tracking <FaArrowRight /></a>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Sitemap;
